import { createFileRoute } from "@tanstack/react-router";
import { TemplateBlockEditor } from "@/features/template-block-editor/template-block-editor";
import { useTestEditorConfig } from "@/features/test-template/template-block-editor-adapter";

export const Route = createFileRoute(
  "/analytics/templates/$template_id/attributes",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { template_id } = Route.useParams();
  const config = useTestEditorConfig(template_id);
  return <TemplateBlockEditor config={config} />;
}
